document.addEventListener('DOMContentLoaded', function () {
  console.log('[Klaviyo Contact] JS loaded'); // 👈 add this

  var form = document.getElementById('ContactForm');
  if (!form) return;

  // ... rest of your code ...
});


// assets/fill-contact-meta.js
document.addEventListener('DOMContentLoaded', function () {
  // safe-get by id
  function $id(id) { return document.getElementById(id); }

  var pageInput = $id('cf-page-url');
  var refInput  = $id('cf-referrer');

  // If the inputs exist and are empty, fill them
  if (pageInput && (!pageInput.value || pageInput.value.trim() === '')) {
    try {
      pageInput.value = window.location.href;
    } catch (e) {
      pageInput.value = document.location && document.location.href ? document.location.href : '';
    }
  }

  if (refInput && (!refInput.value || refInput.value.trim() === '')) {
    // document.referrer is the browser referrer (client-side fallback)
    refInput.value = document.referrer || '';
  }

  // run the same filling when the DOM changes (small MutationObserver)
  var contactForm = $id('ContactForm');
  if (!contactForm) {
    // try again if the form is injected later
    var observer = new MutationObserver(function (mutations, obs) {
      var formNow = $id('ContactForm');
      if (formNow) {
        if (pageInput && (!pageInput.value || pageInput.value.trim() === '')) pageInput.value = window.location.href;
        if (refInput  && (!refInput.value  || refInput.value.trim() === '')) refInput.value = document.referrer || '';
        obs.disconnect();
      }
    });
    observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }
});


// After JS code to populate page URL and Referrer URL === STARTING to forward the form to our VERSEL SERVER


// assets/contact-form-klaviyo.js

document.addEventListener('DOMContentLoaded', function () {
  console.log('[Klaviyo Contact] JS loaded');

  var form = document.getElementById('ContactForm');
  if (!form) return;

  function buildPayload(form) {
    var fd = new FormData(form);
    var payload = {};

    fd.forEach(function (value, key) {
      payload[key] = value;
    });

    // Optional: include shop origin so server can verify if needed
    payload._shop_origin = window.location.hostname;

    return payload;
  }

  function sendPayload(payload) {
    try {
      // Use the stable Vercel project domain
      var url = 'https://easybreezyporchswings.vercel.app/api/klaviyo-contact';

      var body = JSON.stringify(payload);

      // Use fetch (no sendBeacon) so we can see real POST + response
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true,
        credentials: 'omit'
      }).catch(function (err) {
        console.warn('Forward failed', err);
      });
    } catch (e) {
      console.warn('Payload send error', e);
    }
  }

  form.addEventListener('submit', function () {
    try {
      var payload = buildPayload(form);
      sendPayload(payload);
      // Do NOT preventDefault – let Shopify submit the normal contact form
    } catch (err) {
      console.error('Contact forward error', err);
    }
  });
});
